<ng-container *ngIf="!charge">
    <h3 mat-dialog-title>Loading Invoice</h3>
    <mat-dialog-content>
        <div class="d-loading">
            <div class="loader">Loading...</div>
        </div>
    </mat-dialog-content>
</ng-container>
<ng-container *ngIf="charge">
    <h3 mat-dialog-title>Invoice: {{ charge.title }}</h3>
    <mat-dialog-content>
        <div (click)="clickGuard($event);" class="row mb-4">
            <div class="col-md-6 col-sm-12">
                <table class="table table-bordered cells-right">
                    <tr>
                        <th>Original Amount:</th>
                        <td>{{ (charge.chargeAmount | legfiCurrency:charge.currency:'symbol':'.2') }}</td>
                    </tr>
                    <tr *ngIf="charge.daysOverdue">
                        <th>Days Overdue:</th>
                        <td>{{ charge.daysOverdue }}</td>
                    </tr>
                    <tr *ngIf="charge.expectedTotal && charge.expectedTotal != charge.chargeAmount">
                        <th>Current Total:</th>
                        <td>{{ charge.expectedTotal | legfiCurrency:charge.currency:'symbol':'.2' }}</td>
                    </tr>
                    <tr *ngIf="charge.paymentsSum && charge.paymentsSum > 0">
                        <th>Previous Payments:</th>
                        <td>{{ charge.paymentsSum | legfiCurrency:charge.currency:'symbol':'.2' }}</td>
                    </tr>
                    <tr>
                        <th>Remaining Balance:
                            <small (click)="updateChargeBalance()" *ngIf="jwt.superUser" class="d-block add-hover text-primary">
                                Recalculate
                                <app-super-star></app-super-star>
                            </small>
                        </th>
                        <td>{{ charge.balance | legfiCurrency:charge.currency:'symbol':'.2' }}</td>
                    </tr>
                    <tr *ngIf="charge.paid && charge.expectedTotal < charge.paymentsSum">
                        <th>Overpayment:</th>
                        <td>{{ (charge.paymentsSum - charge.expectedTotal) | legfiCurrency:charge.currency:'symbol':'.2' }}</td>
                    </tr>
                    <tr>
                        <th>Category:</th>
                        <td>
                            {{ charge.category && charge.category.name ? charge.category.name : 'Uncategorized' }}
                            <div class="text-muted mt-2" *ngIf="accrualAccounting && charge.openingBalance" matTooltip="Starting Balance invoices are posted to Opening Balance Equity. The income category displayed will only be used for cash-based accounting.">
                                Starting Balance
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="charge.deletedAt">
                        <th class="text-danger">Deleted At:</th>
                        <td>
                            {{ charge.deletedAt | legfiDate:'MM/DD/YYYY' }}
                            <br *ngIf="charge.lastActivity && charge.lastActivity.user"/>
                            <span *ngIf="charge.lastActivity && charge.lastActivity.user">
                        by {{ charge.lastActivity.user.name || charge.lastActivity.user.email }}
                    </span>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="col-md-6 col-sm-12">
                <table class="table table-bordered">
                    <tr>
                        <th>Active On:</th>
                        <td>{{ charge.activeAfter | legfiDate:'MM/DD/YYYY' }}</td>
                    </tr>
                    <tr>
                        <th>Active At:</th>
                        <td>{{ charge.activeAfter | legfiDate:'MM/DD/YYYY h:mm:ss a' }}</td>
                    </tr>
                    <tr>
                        <th>Due On:</th>
                        <td>{{ charge.paymentDueOn | legfiDate:'MM/DD/YYYY' }}</td>
                    </tr>
                    <tr>
                        <th>Past Due After:</th>
                        <td>{{ charge.paymentDueOn | legfiDate:'MM/DD/YYYY h:mm:ss a' }}</td>
                    </tr>

                </table>
            </div>
        </div>

        <div *ngIf="charge.notes && charge.notes.length" class="card">
            <div class="card-header">
                <h2>Notes</h2>
            </div>
            <table class="table">
                <thead>
                <tr>
                    <th>Created</th>
                    <th>Note</th>
                </tr>
                </thead>
                <tbody>
                <!--suppress HtmlUnknownAttribute -->
                <ng-template [ngForOf]="charge.notes" let-note ngFor>
                    <!--suppress HtmlUnknownAttribute -->
                    <tr>
                        <td data-label="Created">
                            {{ note.createdAt | legfiDate:'MM/DD/YYYY' }}
                        </td>
                        <td data-label="Note">
                            {{ note.note }}
                        </td>
                    </tr>
                </ng-template>
                </tbody>
            </table>
        </div>

        <div *ngIf="charge.lateFees.length || charge.lateFee || charge.earlyDiscount" class="card">
            <div class="card-header">
                <h2>Discounts and Fees</h2>
            </div>
            <table class="table">
                <thead>
                <tr>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Effective Date</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="charge.earlyDiscount">
                    <td>Early Discount</td>
                    <td>{{ charge.earlyDiscount | legfiCurrency:'USD':'symbol':'.2' }}</td>
                    <td>
                        <span *ngIf="charge.early">
                            Expires
                        </span>
                        <span *ngIf="!charge.early">
                            Expired
                        </span>
                        <span matTooltip="Early before {{charge.earlyBefore | legfiDate:'MM/DD/YYYY h:mm:ss a'}}">
                            {{ charge.earlyBefore | legfiDate:'MM/DD/YYYY' }}
                        </span>
                    </td>
                </tr>
                <tr *ngIf="charge.lateFee">
                    <td>Late Fee<span *ngIf="jwt.superUser"> (Legacy)</span> <button (click)="removeLateFee()"
                                                                                *ngIf="jwt.superUser" class="btn btn-link p-0">Remove
                        <app-super-star></app-super-star>
                    </button></td>
                    <td>{{ charge.lateFee | legfiCurrency:'USD':'symbol':'.2' }}</td>
                    <td>
                        <span *ngIf="charge.late">
                            Applied
                        </span>
                        <span *ngIf="!charge.late">
                            Applies
                        </span>
                        <span matTooltip="{{charge.lateAfter | legfiDate:'MM/DD/YYYY h:mm:ss a'}}">
                            {{ charge.lateAfter | legfiDate:'MM/DD/YYYY' }}
                        </span>
                    </td>
                </tr>
                <ng-template *ngIf="charge.lateFees" [ngForOf]="charge.lateFees" let-item ngFor>
                    <tr>
                        <td *ngIf="item.lateFeeType === 'one-time'">
                            One-Time Late Fee
                        </td>
                        <td *ngIf="item.lateFeeType === 'one-time'">
                            <span *ngIf="item.oneTimeLateFeeType === 'flat'">
                                {{ item.oneTimeLateFeeAmount | legfiCurrency:'USD':'symbol':'.2' }}
                            </span>
                            <span *ngIf="item.oneTimeLateFeeType === 'interest-simple'">
                                {{ item.oneTimeLateFeeAmount / 100 }} % balance
                            </span>
                            <span *ngIf="item.oneTimeLateFeeType === 'interest-compound'">
                                {{ item.oneTimeLateFeeAmount / 100 }} % balance + fees
                            </span>
                        </td>
                        <td *ngIf="item.lateFeeType === 'one-time'">
                            <span matTooltip="{{item.oneTimeLateFeeApplies | legfiDate:'MM/DD/YYYY h:mm:ss a'}}">
                                {{ item.oneTimeLateFeeApplies | legfiDate:'MM/DD/YYYY' }}
                            </span>
                        </td>

                        <td *ngIf="item.lateFeeType === 'recurring'">
                            Recurring Late Fee
                        </td>
                        <td *ngIf="item.lateFeeType === 'recurring'">
                            <span *ngIf="item.recurringLateFeeType === 'flat'">
                                {{ item.recurringLateFeeAmount | legfiCurrency:'USD':'symbol':'.2' }}
                            </span>
                            <span *ngIf="item.recurringLateFeeType === 'interest-simple'">
                                {{ item.recurringLateFeeAmount / 100 }} % balance
                            </span>
                            <span *ngIf="item.recurringLateFeeType === 'interest-compound'">
                                {{ item.recurringLateFeeAmount / 100 }} % balance + fees
                            </span>
                        </td>
                        <td *ngIf="item.lateFeeType === 'recurring'">
                            Starting
                            <span matTooltip="{{item.recurringLateFeeBegins | legfiDate:'MM/DD/YYYY h:mm:ss a'}}">
                                {{ item.recurringLateFeeBegins | legfiDate:'MM/DD/YYYY' }}
                            </span>
                            and repeating every
                            {{ item.recurringLateFeeIntervalValue }}
                            {{ item.recurringLateFeeInterval }}
                            <br>
                            Next applies {{ item.recurringLateFeeNextApplies | legfiDate:'MM/DD/YYYY' }}
                        </td>
                    </tr>
                </ng-template>
                </tbody>
            </table>
        </div>

        <div class="card">
            <div class="card-header">
                <h2>Invoice History</h2>
            </div>
            <table class="table">
                <thead>
                <tr>
                    <th>Activity</th>
                    <th>Date</th>
                    <th>Invoice</th>
                    <th>Payment</th>
                    <th>Balance</th>
                    <th *ngIf="jwt.superUser"></th>
                </tr>
                </thead>
                <tbody>
                <!--suppress HtmlUnknownAttribute -->
                <ng-template *ngIf="charge.history.length" [ngForOf]="charge.history" let-item ngFor>
                    <tr *ngIf="item">
                        <td data-label="Activity">
                            {{ item.activityType }}
                        </td>
                        <td data-label="Date" matTooltip="{{item.activityDate | legfiDate:'MM/DD/YYYY h:mm:ss a'}}">
                            {{ item.activityDate | legfiDate:'MM/DD/YYYY' }}
                        </td>
                        <td data-label="Invoice">
                            <span *ngIf="item.charge > 0">{{ (item.charge) | legfiCurrency:'USD':'symbol':'.2' }}</span>
                        </td>
                        <td data-label="Payment">
                            <span *ngIf="item.payment > 0">{{ (item.payment) | legfiCurrency:'USD':'symbol':'.2' }}</span>
                        </td>
                        <td data-label="Balance">
                            {{ (item.balance || 0) | legfiCurrency:'USD':'symbol':'.2' }}
                        </td>
                        <td *ngIf="jwt.superUser && item.paymentItemId">
                            <button (click)="creditPaymentItem(item)" class="btn btn-link p-0">
                                Issue Credit
                                <app-super-star></app-super-star>
                            </button>
                        </td>
                    </tr>
                </ng-template>
                <tr *ngIf="!charge.history.length">
                    <td colspan="5">
                        No invoice history to show.
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="charge && charge.children.length > 0" class="card">
            <div class="card-header justify-content-between d-flex flex-wrap">
                <h2>Late Fees Applied</h2>
                <lf-multi-charge-options *ngIf="hasWriteAccess" [charges]="selectedChildCharges"></lf-multi-charge-options>
            </div>
            <table class="table">
                <thead>
                <tr>
                    <th>
                        <mat-checkbox (change)="toggleAllChildren()"
                                      [checked]="this.selectedChildCharges.selected.length === this.charge.children.length"
                                      [indeterminate]="selectedChildCharges.hasValue()">
                        </mat-checkbox>
                    </th>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Amount</th>
                    <th>Balance</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <!--suppress HtmlUnknownAttribute -->
                <ng-template [ngForOf]="charge.children" let-item ngFor>
                    <tr *ngIf="item">
                        <td>
                            <mat-checkbox (change)="selectedChildCharges.toggle(item)"
                                          [checked]="selectedChildCharges.isSelected(item)">
                            </mat-checkbox>
                        </td>
                        <td data-label="Date" matTooltip="{{item.activeAfter | legfiDate:'MM/DD/YYYY h:mm:ss a'}}">
                            {{ item.activeAfter | legfiDate:'MM/DD/YYYY' }}
                        </td>
                        <td data-label="Description">
                            {{ item.description }}
                        </td>
                        <td *ngIf="!item.deletedAt" data-label="Amount">
                            {{ (item.chargeAmount) | legfiCurrency:'USD':'symbol':'.2' }}
                        </td>
                        <td *ngIf="!item.deletedAt" data-label="Balance">
                            {{ (item.balance || 0) | legfiCurrency:'USD':'symbol':'.2' }}
                        </td>
                        <td *ngIf="item.deletedAt" class="text-danger" colspan="2">
                            Deleted {{ item.deletedAt | legfiDate:'MM/DD/YYYY h:mm:ss a' }}
                        </td>
                        <td>
                            <lf-single-charge-options [charge]="item"></lf-single-charge-options>
                        </td>
                    </tr>
                </ng-template>
                </tbody>
            </table>
        </div>

        <div class="card mt-4" *ngIf="hasAccountingV2 && jwt.admin && charge?.ledgerEntries?.length">
            <div class="card-header d-flex justify-content-between">
                <h2>Ledger Entries</h2>
            </div>
            <div class="card-body p-0">
                <table class="table m-0">
                    <thead>
                    <tr>
                        <th>Entry Date</th>
                        <th>Account</th>
                        <th class="text-right">Debit</th>
                        <th class="text-right">Credit</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--suppress HtmlUnknownAttribute -->
                    <ng-template [ngForOf]="charge.ledgerEntries | groupBy:'batchId'" let-group ngFor>
                        <tr>
                            <td colspan="2" matTooltip="Created {{group[0].createdAt | legfiDate}}">
                                {{ group[0].description }}
                            </td>
                            <td colspan="2" class="text-right">
                                <button class="btn btn-link p-0 m-0" *ngIf="jwt.superUser" (click)="deleteLedgerBatch(group[0].batchId)">
                                    Delete Batch
                                    <app-super-star></app-super-star>
                                </button>
                            </td>
                        </tr>
                        <ng-template [ngForOf]="group" let-item ngFor>
                            <!--suppress HtmlUnknownAttribute -->
                            <tr>
                                <td>
                                    {{ item.entryDate | legfiDate }}
                                </td>
                                <td>
                                    {{ item.account?.name }}
                                </td>
                                <td class="text-right">
                                    {{ item.debit | legfiCurrency }}
                                </td>
                                <td class="text-right">
                                    {{ item.credit | legfiCurrency }}
                                </td>
                            </tr>
                        </ng-template>
                    </ng-template>
                    </tbody>
                    <tfoot>
                    <tr>
                        <th>Total</th>
                        <th></th>
                        <th class="text-right">{{ charge.ledgerEntries | sum:'debit' | legfiCurrency }}</th>
                        <th class="text-right">{{ charge.ledgerEntries | sum:'credit' | legfiCurrency }}</th>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button (click)="forgiveCharge()"
                *ngIf="hasWriteAccess && !charge.paid && !charge.deletedAt" class="btn btn-outline-danger">
            <i class="fa fa-undo"></i>
            Forgive
        </button>
        <button (click)="editCharge()"
                *ngIf="(hasWriteAccess && (!charge.paid && !charge.deletedAt)) || jwt.superUser" class="btn btn-outline-primary">
            <i class="fa fa-pencil"></i>
            Edit
        </button>
    </mat-dialog-actions>
</ng-container>
